import { Box, Paper, Skeleton } from "@mui/material";
import type { FC } from "react";

export const DigitalSampleCardSkeleton: FC<any> = () => {
  return (
    <Paper variant="outlined">
      <Box display="flex" flexDirection="row">
        <Skeleton variant="rectangular" width={120} height={120}></Skeleton>
        <Box padding={2} width={180}>
          <Skeleton height={20}></Skeleton>
          <Skeleton height={20}></Skeleton>
        </Box>
      </Box>
    </Paper>
  );
};
